export { default } from './LoaderIcon';